export const splashContainer = '.js-splash';
export const splashRunCookieName = 'splash-run';
export const splashShowClass = 'show-splash';
export const cookieBannerContainer = '.js-cookie-banner';
export const cookiesAcceptedCookieName = 'cookieMessageAccepted';
export const cookieBannerShowClass = 'show-cookie-banner';
export const pageBannerEndId = 'page-banner-end';
